module.exports = __webpack_public_path__ + "img/1-2301111K250621.5a4c59e7.png";